const Badge = ({
  heading,
  className,
  variant,
  type = 'text',
}: {
  heading: string
  className?: string
  variant: 'success' | 'warning' | 'danger'
  type?: 'outline' | 'solid' | 'text'
}) => {
  // TODO: Add relevant code for outline and solid styles
  const variantClasses = {
    success: {
      text: 'ds-text-green-800  ds-font-500 ds-leading-[20px] ds-font-mono',
      outline:
        'ds-border ds-border-green-700 ds-text-green-800 ds-rounded-[8px] ds-px-[12px] ds-py-[4px]',
      solid:
        'ds-bg-green-700 ds-text-white ds-rounded-[12px] ds-px-[12px] ds-py-[14px]',
    },
    warning: {
      text: 'ds-text-orange-700 ds-font-500 ds-leading-[20px] ds-font-mono',
      outline:
        'ds-border ds-border-orange-700 ds-text-orange-800 ds-rounded-[8px] ds-px-[12px] ds-py-[4px]',
      solid:
        'ds-bg-orange-700 ds-text-white ds-rounded-[12px] ds-px-[12px] ds-py-[14px]',
    },
    danger: {
      text: 'ds-text-red-700 ds-font-500 ds-leading-[20px] ds-font-mono',
      outline:
        'ds-border ds-border-red-700 ds-text-red-800 ds-rounded-[8px] ds-px-[12px] ds-py-[4px]',
      solid:
        'ds-bg-red-700 ds-text-white ds-rounded-[12px] ds-px-[12px] ds-py-[14px]',
    },
  }

  const dotClasses = {
    success: 'ds-bg-green-800',
    warning: 'ds-bg-orange-500',
    danger: 'ds-bg-red-600',
  }

  return (
    <div
      className={`ds-rounded-full ds-inline-flex ds-h-[24px] ds-items-center ds-gap-[6px] ds-uppercase ${variantClasses[variant][type]} ${className || ''}`}
    >
      {type === 'text' && (
        <div
          className={`ds-h-[8px] ds-w-[8px] ds-flex-shrink-0 ds-rounded-[50%] ${dotClasses[variant]}`}
        />
      )}
      <span>{heading}</span>
    </div>
  )
}

export { Badge }
